import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetTE_MAinTeamMembersPreviousExperiencePartnershipsData =
  createAsyncThunk(
    "TE_MAinTeamMembersPreviousExperiencePartnerships/GetTE_MAinTeamMembersPreviousExperiencePartnershipsData",
    async (AI_ApplicationInformationId, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/TE_MAinTeamMembersPreviousExperiencePartnerships/GetTE_MAinTeamMembersPreviousExperiencePartnershipsData",
          {
            AI_ApplicationInformationId: AI_ApplicationInformationId,
          }
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "datSSSSSSSSSSSSSSSSSSSSSSSSaa");

        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

export const ValidateTE_MAinTeamMembersPreviousExperiencePartnershipsD =
  createAsyncThunk(
    "TE_MAinTeamMembersPreviousExperiencePartnerships/ValidateTE_MAinTeamMembersPreviousExperiencePartnershipsD",
    async (AI_ApplicationInformationId, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/TE_MAinTeamMembersPreviousExperiencePartnerships/ValidateTE_MAinTeamMembersPreviousExperiencePartnershipsD",
          {
            AI_ApplicationInformationId: AI_ApplicationInformationId,
          }
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "datSSSSSSSSSSSSSSSSSSSSSSSSaa");
        if (response.data.success === true) {
          const arrayValidate = response.data.result.map((ele, ind) => {
            return ele.code;
          });
          return arrayValidate; // Return the extracted data
        }
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
const TeamMembersPreviousExperiencePartnerships = createSlice({
  name: "TeamMembersPreviousExperiencePartnerships",
  initialState: {
    TeamMembersPreviousExperiencePartnerships: {},
    loadingGetTE_MAinTeamMembersPreviousExperiencePartnershipsData: false,
    errorGetTE_MAinTeamMembersPreviousExperiencePartnershipsData: null,
    //----------------------validate----------------------------
    TeamMembersPreviousValidationPage: [],
    loadingTeamMembersPreviousValidationPage: false,
    errorTeamMembersPreviousValidationPage: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        GetTE_MAinTeamMembersPreviousExperiencePartnershipsData.pending,
        (state, action) => {
          state.loadingGetTE_MAinTeamMembersPreviousExperiencePartnershipsData = true;
          state.TeamMembersPreviousExperiencePartnerships = action.payload;
          state.errorGetTE_MAinTeamMembersPreviousExperiencePartnershipsData =
            null;
        }
      )
      .addCase(
        GetTE_MAinTeamMembersPreviousExperiencePartnershipsData.fulfilled,
        (state, action) => {
          state.loadingGetTE_MAinTeamMembersPreviousExperiencePartnershipsData = false;
          state.TeamMembersPreviousExperiencePartnerships = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetTE_MAinTeamMembersPreviousExperiencePartnershipsData.rejected,
        (state, action) => {
          state.loadingGetTE_MAinTeamMembersPreviousExperiencePartnershipsData = false;
          state.errorGetTE_MAinTeamMembersPreviousExperiencePartnershipsData =
            action.payload;
        }
      )
      //-------------------------------------------------------------------------
      .addCase(
        ValidateTE_MAinTeamMembersPreviousExperiencePartnershipsD.pending,
        (state, action) => {
          state.loadingTeamMembersPreviousValidationPage = true;
          state.TeamMembersPreviousValidationPage = action.payload;
          state.errorTeamMembersPreviousValidationPage = null;
        }
      )
      .addCase(
        ValidateTE_MAinTeamMembersPreviousExperiencePartnershipsD.fulfilled,
        (state, action) => {
          state.loadingTeamMembersPreviousValidationPage = false;
          state.TeamMembersPreviousValidationPage = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        ValidateTE_MAinTeamMembersPreviousExperiencePartnershipsD.rejected,
        (state, action) => {
          state.loadingTeamMembersPreviousValidationPage = false;
          state.errorTeamMembersPreviousValidationPage = action.payload;
        }
      );
  },
});
export default TeamMembersPreviousExperiencePartnerships.reducer;
